/** LangGraph thread_id / AgentCore config.session_id (per conversation, not WebSocket connection id). */
export function newAgentSessionId(): string {
  return `session-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`
}
